export const LOGOUT_MENU_ITEM_TEST_ID = 'logout-menu-item';
